import { DefinitionDescription, DefinitionTerm } from "@/components/ui/definition-list.tsx";
import usePowerSupplyDimmingType from "@/features/sub-families/hooks/use-power-supply-dimming-type.ts";
import { useTranslations } from "@/features/translations/components/translations.tsx";

export default function DimmingTypeDetails() {
    const t = useTranslations();
    const powerSupplyDimmingType = usePowerSupplyDimmingType();

    if (!powerSupplyDimmingType) return null;

    const { selectedDimmingTypeLabel } = powerSupplyDimmingType;

    if (!selectedDimmingTypeLabel) return null;

    return (
        <>
            <DefinitionTerm>{t("dimming_type")}</DefinitionTerm>
            <DefinitionDescription>{selectedDimmingTypeLabel}</DefinitionDescription>
        </>
    );
}
